<template>
  <div>
    <topbar title="Trattamento dei dati" :largeTitle="true"  :showBack="true" @back="$router.go(-1)" />
    
    <div v-once class="p-3 max-w-3xl mx-auto w-full">
      <p class="subtitle">Informativa sul trattamento dei dati personali</p>
      <p>Questa informativa stabilisce i principi con i quali verranno raccolti, trattati ed utilizzati i dati degli utenti nell’ambito del progetto <i>lìdatè</i>. Utilizzando la piattaforma web si acconsente a tutte le azioni intraprese dall’Osservatorio linguistico della Svizzera italiana (OLSI) in relazione alle informazioni personali in conformità con questi termini. I dati verranno raccolti, trattati e utilizzati per personalizzare l’esperienza degli utenti e per studiare la geografia della lingua italiana.</p>
      <p class="font-bold mt-4 mb-2">Principi di confidenzialità</p>
      <p>L’Osservatorio linguistico della Svizzera italiana (OLSI), in veste di titolare della piattaforma web <i>lìdatè</i>, si impegna a:</p>
      <ol class="list-decimal">
        <li>trattare i dati con riservatezza all’interno di un accordo di confidenzialità con i partner di progetto;</li>
        <li>mantenere la confidenzialità delle informazioni personali, il nome e la email, e trattare i dati dell’indagine in forma anonima;</li>
        <li>utilizzare i dati unicamente nell’ambito del menzionato progetto <i>lìdatè</i>, consentendone l’accesso unicamente ai propri collaboratori direttamente coinvolti nel progetto;</li>
        <li>non trasmettere i dati ad alcuna persona, organizzazione o entità terza senza l’esplicito e preventivo consenso scritto;</li>
        <li>non diffondere né i dati forniti né elaborazioni statistiche dei dati che permettano l’identificazione delle singole persone interessate;</li>
        <li>utilizzare e proteggere le informazioni personali in conformità alla General Data Protection Regulation (UE) 2016/679 – GDPR e la relativa legislazione svizzera applicabile in materia di protezione dei dati, adottando tutte le misure di sicurezza contro la perdita, il furto, l’elaborazione e la consultazione illecita dei dati.</li>
      </ol>
      
      <p class="font-bold mt-4 mb-2">Diritto di rifiuto</p>
      <p>La partecipazione è volontaria e il rifiuto a partecipare a questo progetto non penalizza la persona. Il partecipante al progetto <i>lìdatè</i> ha il diritto di ritirarsi da quest’ultimo in qualsiasi momento, senza perdita di diritti o benefici.</p>

      <p class="font-bold mt-4 mb-2">Terze parti</p>
      <p>La piattaforma web contiene contenuti di terze parti che sono protetti da copyright. Con l’iscrizione al progetto <i>lìdatè</i> il partecipante accetta la presenza di servizi e contenuti forniti da terze parti per migliorare l’esperienza d’uso.</p>

      <p class="font-bold mt-4 mb-2">Raccolta dei dati</p>
      <p>
        <i>lìdatè</i> raccoglie due tipi di informazioni: i dati personali e le statistiche condivise.<br>
        I dati personali sono quelli che l’utente fornisce durante la registrazione e saranno mantenuti in forma confidenziale.<br>
        Le statistiche condivise riguardano l’uso di determinate espressioni geograficamente localizzate. Tali statistiche subiscono un processo di anonimizzazione completo, che rende non identificabile il singolo utente e sono rese pubbliche sul sito www.lidate.ch.
      </p>

      <p class="font-bold mt-4 mb-2">Utilizzo delle informazioni personali</p>
      <p>
        L’Osservatorio linguistico della Svizzera italiana (OLSI) potrebbe usare le informazioni personali, come il nome e l’indirizzo email, per:
      </p>
      <ul>
        <li>rispondere alle richieste pervenute via email e ai commenti ai post su piattaforme social o inviare delle newsletter con gli aggiornamenti sul progetto;</li>
        <li>inviare notizie e informazioni via email che riguardano gli sviluppi della ricerca;</li>
      </ul>

      <p class="font-bold mt-4 mb-2">Utilizzo dei dati</p>
      <p>
        L’aggregazione delle risposte nella sezione “Come lo dici?” consente di delineare la distribuzione geografica della lingua italiana e contribuire alla ricerca linguistica dell’Osservatorio linguistico della Svizzera italiana (OLSI).<br>
        La raccolta, l’elaborazione, l’analisi e la pubblicazione in forma anonima delle statistiche hanno come unico scopo la ricerca condotta ai fini della divulgazione scientifica.
      </p>

      <p class="font-bold mt-4 mb-2">Come disattivare l’account</p>
      <p>
        Puoi disattivare il tuo account <i>lìdatè</i> inviando una mail dall’indirizzo con cui ti sei registrato a: info@lidate.ch.<br>
        Con la disattivazione dell’account i tuoi dati saranno rimossi dal server di <i>lìdatè</i> tramite un processo automatizzato. La cancellazione completa potrebbe richiedere qualche ora.<br>
        <i>lìdatè</i> può continuare ad utilizzare le statistiche generate dalla compilazione delle domande nella sezione “Come lo dici?” dopo che queste saranno anonimizzate, rendendo impossibile l’identificazione.<br>
        Con la disattivazione dell’account saranno, inoltre, rimossi i tuoi dati personali dai servizi di terze parti.<br>
      </p>

      <p class="font-bold mt-4 mb-2">Ulteriori informazioni</p>
      <p>
        In caso di commenti o domande riguardanti il trattamento dei dati personali è possibile inviare una mail all’indirizzo info@lidate.ch.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  }
</script>

<style scoped>
  .subtitle {
    @apply font-bold text-xl mt-4 mb-2;
  }
  p {
    @apply mb-2;
  }
  ul {
    @apply mb-2 list-disc;
  }
  li {
    @apply ml-5;
  }

  
</style>